// CarGurus icon - C and G from official logo
// Red: #ef3742, Blue: #00a0dd

export function CarGurusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 47" width={24} height={12} style={{ stroke: 'none' }}>
            {/* Red C with face */}
            <g fill="#ef3742">
                <path d="m34.68 30.646c-2.463 5.439-7.44 8.672-13.239 8.672-8.313 0-15.035-7.286-15.035-16.266s6.773-16.267 15.035-16.267c6.004 0 10.827 3.181 13.239 8.672l.103.257h6.26l-.205-.616c-2.772-8.724-10.212-14.111-19.397-14.111-11.597 0-20.987 9.852-20.987 22.013s9.39 22.065 20.987 22.065c9.082 0 16.523-5.439 19.396-14.162l.205-.616h-6.209z"/>
                <path d="M20.107 18.228h3.9v11.443h-3.9z"/>
                <circle cx="29.292" cy="19.973" r="2.258"/>
                <circle cx="14.77" cy="19.973" r="2.258"/>
            </g>
            {/* Blue G with face - translated to be next to C */}
            <g fill="#00a0dd" transform="translate(-62, 0)">
                <path d="m146.851 23.667c-.308 8.826-6.671 15.497-14.727 15.497-8.415 0-15.291-7.286-15.291-16.164 0-8.929 6.876-16.215 15.291-16.215 5.696 0 10.571 3.233 13.085 8.672l.103.257h6.414l-.205-.616c-3.027-8.723-10.622-14.316-19.396-14.316-11.751 0-21.295 9.955-21.295 22.167s9.544 22.167 21.295 22.167a19.909 19.909 0 0 0 14.265-5.952 21.58 21.58 0 0 0 6.158-15.497z"/>
                <circle cx="131.867" cy="17.663" r="2.36"/>
                <circle cx="140.847" cy="17.663" r="2.36"/>
            </g>
        </svg>
    );
}
